import React from 'react'
import * as ReactDOMClient from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import './styles/index.scss'
import { Provider } from 'react-redux'
import store from './store/reducers'
import { PublicClientApplication } from '@azure/msal-browser'
import { MsalProvider } from '@azure/msal-react'
import { msalConfig } from './authConfig'
import ErrorBoundary from './Helpers/ErrorBoundary'

const root = ReactDOMClient.createRoot(document.getElementById('root'))
const instance = new PublicClientApplication(msalConfig)
root.render(
    <Provider store={store}>
        <BrowserRouter>
        <ErrorBoundary>
            <MsalProvider instance={instance}>
                <App instance={instance} />
            </MsalProvider>
            </ErrorBoundary>
        </BrowserRouter>
    </Provider>
)
